import React from "react";
import {
  Row,
  Col,
  Image,
  Button,
  Space,
  Dropdown,
  message,
  Modal,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";

import withRouter from "../withRouter";
import GradeTimingStore from "../store/GradeTimingStore";
import CompanyStore from "../store/CompanyStore";
import GradeTimingAdd from "./GradeTimingAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CloseOutlined } from "@ant-design/icons";

class GradeTimingList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.companyStore = new CompanyStore(this);

    this.onDelete = this.onDelete.bind(this);

    this.gradTimingStore = new GradeTimingStore();

    // console.log(this.context);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      company_value_label: "",
      openGradeForm: false,
      listDataUpdate: false,
      grade_Id: "",
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Grade",
        title: context.translate("_GRADE_"),
        width: 150,
        dataIndex: "className",
        key: "grade",
        fixed: "left",
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("gradetiminglist") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Start Time",
        title: context.translate("_FLEET_START_TIME_"),
        width: 150,
        dataIndex: "startTime",
        key: "startTime",
        fixed: "left",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "End Time",
        title: context.translate("_END_TIME_"),
        width: 150,
        dataIndex: "stopTime",
        key: "endtime",
        fixed: "left",
        ellipsis: {
          showTitle: true,
        },
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        fixed: "right",
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        width: 50,
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("gradetiminglist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("gradetiminglist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px",}}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_DASHBOARD_"),
          key: "dashboard",
          icon: (
            <i
              class="bi bi-speedometer2"
              style={{ marginInlineEnd: "5px" }}
            ></i>
          ),
        },
      ],
    };
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    await this.setState({ pageSize: 50 });
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      console.log("in");
      const beforeEditCompanyId =
        this.context.viewStateStore.gradeTimingObject.companyId;
      await this.gradTimingStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: beforeEditCompanyId,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        this.context.viewStateStore.gradeTimingObject.companyId
      );
      await this.setState({ loadList: 1 }); //need to reload data
      await this.setState({ company_value_label: singleData });
      await this.setState({ listDataUpdate: false });
      // await this.setState({ pageSize: 50 });
    }
  }

  onEdit = async (record) => {
    console.log(record.passengerId);
    const gradeId = record.grade_Id;
    await this.context.viewStateStore.setGradeTimingStates({
      companyId: record.companyId,
    });
    // if (gradeId) {
    //   this.props.navigate("/gradetimingadd/" + gradeId)
    // }
    await this.setState({ grade_Id: gradeId });
    await this.setState({ openGradeForm: true });
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.gradTimingStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {
    console.log(record);
    const response = await this.gradTimingStore.deleteRecord({
      grade_Id: record.grade_Id,
    });
    // console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  closeModal = () => {
    this.setState({ openGradeForm: false, grade_Id: "" });
  };

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.success == "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openGradeForm: false });

      //  await this.handleSearch();
      // this.props.navigate("/gradetiminglist");
    } else if (resp.success == "F0") {
      resp.errors.map((value) => {
        message.error(value["grade"]);
      });
      console.log(resp.data.errors[0].grade);
      message.error(resp.data.errors[0].grade);
    }
  };

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.gradTimingStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  render() {
    return (
      <>
        <div className="listHeader">
          {/* <div className='heading'>Grade Timings List</div> */}
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  // allowClear={true}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "30px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              <Dropdown
                overlayClassName="export-dropdown"
                menu={this.ExportMenuProps}
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    marginInlineEnd: "30px",
                  }}
                  src={kebabIcon}
                ></Image>
              </Dropdown>

              {this.props.canCreate("gradetiminglist") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openGradeForm: true, grade_Id: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
            {/* <Col span={8}>
                  <Space style={{float:this.context.locale.direction=="ltr"?"right":"left"}}> 
                    <AddButton title={this.context.translate('_ADD_')} link ="/gradetimingadd" />
                      <Button>  
                     DashBoard
                      </Button>
                  </Space>
                </Col> */}
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.gradTimingStore?.total}
            columns={this.columns}
            dataSource={this.gradTimingStore?.gradeTiming}
            loading={this.gradTimingStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openGradeForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openGradeForm}
              placement={this.context.locale.language === "english" ? "right" : "left"}
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_GRADE_BUS_TIMING_DETAILS_")}
                  <p className="formDescription">
                    {this.context.translate("_GRADE_BUS_TIMING_DETAILS_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openGradeForm: false })}
              onCancel={() =>
                this.setState({ openGradeForm: false, grade_Id: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <GradeTimingAdd
                  grade_Id={this.state.grade_Id}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
GradeTimingList.contextType = StoreContext;
export default observer(withRouter(GradeTimingList));
